import React from 'react'
import { IMAGE_BASE } from '../../constants'

export interface LogoProps {
  height?: number
  width?: number
  quality?: number
}

const Logo = ({ height = 22, width = 143, quality = 100 }: LogoProps) => {
  return (
    <img
      decoding='async'
      alt='Cocunat'
      height={height}
      width={width}
      src={`${IMAGE_BASE}?quality=${quality}&fit=cover&image=https://global.cocunat.com/photos/logo.png&width=${width}&height=${height}`}
    />
  )
}

export default Logo
